// extracted by mini-css-extract-plugin
module.exports = {"sortOptionText":"SortAlgorithm_sortOptionText__kO0l6","dropdownButton":"SortAlgorithm_dropdownButton__Dk7_Y","dropdownMenu":"SortAlgorithm_dropdownMenu__uAaHC"};